import styled from 'styled-components'
import { Svg } from '../../assets'

export const BadgeIcon = styled(Svg.Badge)<{ isExpert?: boolean }>`
  margin-left: 8px;
  display: flex;
  fill: ${({ theme }) => theme.palettes.general.blue};
  visibility: ${({ isExpert }) => (isExpert ? 'visible' : 'hidden')};
`
